module.exports = __webpack_public_path__ + "static/media/unpaid.abb2881c.svg";